// import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import CategoryTableRow from "./CategoryTableRow";

import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useState } from "react";

const CategoryData = () => {
  const { categories, isLoading } = useSelector((state) => state.categories);
  console.log("cat", categories);
  const dispatch = useDispatch();

  const [categoryData, setCategoryData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <TableContainer sx={{ whiteSpace: "nowrap" }}>
      <Table aria-label='customized table'>
        <TableHead>
          <TableRow>
            <TableCell>Id</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <TextField
                fullWidth
                helperText='Search by id'
                id='id-searchbox'
                label='Id'

                // onChange={handleSearch}
              />
            </TableCell>
            <TableCell>
              <TextField
                fullWidth
                helperText='Search by name'
                id='name-searchbox'
                label='Name'

                // onChange={handleSearch}
              />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell colSpan={4}>
                <Typography variant='p' align='center'>
                  Loading...
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            <CategoryTableRow row={categories}></CategoryTableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
    // <Typography>Order data</Typography>
  );
};

export default CategoryData;
